import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ListTemplateFilter,
  ListTemplateResponse,
  TemplateData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class TemplateService {
  constructor(private http: HttpClient) {}

  listTemplate(filter: ListTemplateFilter): Observable<ListTemplateResponse> {
    let params = new HttpParams();

    if (filter.media) {
      params = params.append('media', filter.media.toString());
    }

    if (filter.type) {
      params = params.append('type', filter.type.toString());
    }

    if (filter.channel) {
      params = params.append('channel', filter.channel.toString());
    }

    if (filter.template_name) {
      params = params.append('template_name', filter.template_name.toString());
    }

    if (filter.page) {
      params = params.append('page', filter.page.toString());
    }

    if (filter.per_page) {
      params = params.append('per_page', filter.per_page.toString());
    }

    return this.http.get<ListTemplateResponse>(
      environment.apiUrl + 'clientapi/admin/template',
      { params }
    );
  }

  saveTemplate(data: TemplateData): Observable<any> {
    return this.http.put(environment.apiUrl + 'clientapi/admin/template', data);
  }

  addTemplate(data: TemplateData): Observable<any> {
    return this.http.post(environment.apiUrl + 'clientapi/admin/template', data);
  }
}
